/* ============================================
   SOMNIA · Interazioni e animazioni
   Carica in: assets/somnia.js
   ============================================ */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. Header: stato scrolled ---- */
  function initHeader() {
    var header = document.querySelector('.somnia-header');
    if (!header) return;
    function onScroll() {
      if (window.scrollY > 20) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- 2. Barra di progresso scroll ---- */
  function initProgress() {
    var fill = document.querySelector('.somnia-progress__fill');
    if (!fill) return;
    function onScroll() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      var p = h > 0 ? window.scrollY / h : 0;
      fill.style.width = (p * 100) + '%';
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- 3. Reveal on scroll ---- */
  function initReveal() {
    var els = document.querySelectorAll('.somnia-reveal');
    if (!els.length) return;
    if (reduced) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var delay = el.getAttribute('data-delay') || 0;
          el.style.transitionDelay = delay + 's';
          el.classList.add('is-visible');
          obs.unobserve(el);
        }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ---- 4. Count-up numeri ---- */
  function initCountUp() {
    var els = document.querySelectorAll('[data-countup]');
    if (!els.length) return;

    function animate(el) {
      var target = parseFloat(el.getAttribute('data-countup'));
      var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
      if (reduced) { el.textContent = target.toFixed(decimals); return; }
      var duration = 1400;
      var start = performance.now();
      function tick(now) {
        var p = Math.min(1, (now - start) / duration);
        var eased = p === 1 ? 1 : 1 - Math.pow(2, -10 * p);
        el.textContent = (target * eased).toFixed(decimals);
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animate(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ---- 5. Moon cursor ---- */
  function initMoon() {
    var moon = document.querySelector('.somnia-moon');
    if (!moon) return;
    if (reduced || window.matchMedia('(hover: none)').matches) {
      moon.style.display = 'none';
      return;
    }
    var tx = 0, ty = 0, x = 0, y = 0;
    window.addEventListener('mousemove', function (e) {
      tx = e.clientX; ty = e.clientY;
    });
    function loop() {
      x += (tx - x) * 0.14;
      y += (ty - y) * 0.14;
      moon.style.transform = 'translate(' + (x - 6) + 'px,' + (y - 6) + 'px)';
      requestAnimationFrame(loop);
    }
    loop();
  }

  /* ---- 6. Exploded view scroll-driven ---- */
  function initExploded() {
    var section = document.querySelector('[data-exploded]');
    if (!section) return;
    var topper = section.querySelector('[data-exploded-topper]');
    var base = section.querySelector('[data-exploded-base]');
    var labels = section.querySelectorAll('[data-exploded-label]');
    var barFill = section.querySelector('.somnia-exploded__bar-fill');

    function onScroll() {
      var rect = section.getBoundingClientRect();
      var vh = window.innerHeight;
      var range = rect.height - vh;
      var p = Math.max(0, Math.min(1, (vh - rect.top) / (vh + range * 0.6)));

      if (!reduced) {
        if (topper) topper.setAttribute('transform', 'translate(0,' + (-p * 80) + ')');
        if (base) base.setAttribute('transform', 'translate(0,' + (p * 30) + ')');
        var lo = Math.max(0, (p - 0.2) * 2);
        labels.forEach(function (l) { l.style.opacity = lo; });
      }
      if (barFill) barFill.style.width = (p * 100) + '%';
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- 7. Selettore tessuto letto ---- */
  function initBedSwatches() {
    var box = document.querySelector('[data-bed]');
    if (!box) return;
    var swatches = box.querySelectorAll('[data-fabric]');
    var nameEl = box.querySelector('[data-bed-name]');
    var descEl = box.querySelector('[data-bed-desc]');
    var svgMain = box.querySelectorAll('[data-bed-fill]');
    var svgDark = box.querySelectorAll('[data-bed-fill-dark]');

    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        swatches.forEach(function (s) { s.classList.remove('is-active'); });
        sw.classList.add('is-active');

        var color = sw.getAttribute('data-color');
        var dark = sw.getAttribute('data-dark');
        var name = sw.getAttribute('data-name');
        var desc = sw.getAttribute('data-desc');

        if (nameEl) {
          nameEl.textContent = name;
          nameEl.classList.remove('somnia-fade-swap');
          void nameEl.offsetWidth;
          nameEl.classList.add('somnia-fade-swap');
        }
        if (descEl) {
          descEl.textContent = desc;
          descEl.classList.remove('somnia-fade-swap');
          void descEl.offsetWidth;
          descEl.classList.add('somnia-fade-swap');
        }
        svgMain.forEach(function (el) { el.setAttribute('fill', color); });
        svgDark.forEach(function (el) { el.setAttribute('fill', dark); });
      });
    });
  }

  /* ---- init ---- */
  function init() {
    initHeader();
    initProgress();
    initReveal();
    initCountUp();
    initMoon();
    initExploded();
    initBedSwatches();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();